module.exports = __webpack_public_path__ + "img/gaofengxianquyu.ceee46a4.png";